import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';

function StatsCard({ label, value }) {
  return (
    <Card
      sx={{
        borderLeft: 4,
        borderColor: 'primary.main',
      }}
    >
      <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 } }}>
        <Typography
          variant="caption"
          color="text.secondary"
          noWrap
          sx={{ textTransform: 'uppercase', letterSpacing: 0.5, display: 'block' }}
        >
          {label}
        </Typography>
        {/* Values like a date range are long; shrink rather than wrap to a
            column on narrow cards. */}
        <Typography variant="h6" fontWeight={700} color="text.primary" sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }}>
          {value}
        </Typography>
      </CardContent>
    </Card>
  );
}

export default StatsCard;
